import { Box, Text } from '@rbilabs/universal-components';

export const Container = Box.withConfig({
  flexGrow: 1,
  width: 'full',
  alignItems: 'center',
  justifyContent: 'center',
  paddingX: {
    base: '$16',
  },
});

export const ProductTitle = Text.withConfig({
  accessible: true,
  focusable: true,
  lineHeight: 'md',
  margin: 0,
  numberOfLines: 1,
  variant: 'headerOne',
  fontSize: {
    base: '18px',
    md: '24px',
  },
});
